import create from './create'
import update from './update'
import del from './delete'

export default {
  namespaced: true,
  modules: {
    create,
    update,
    del
  }
}
